import { Accordion, AccordionDetails, AccordionSummary, Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { IReadingsInstruments } from '../../../services/api/reading/ReadingServices';
import { ExpandMore } from '@mui/icons-material';

interface AccordionInstrumentsProps {
    data: IReadingsInstruments[];
    type: string;
    titulo: string;
}

export const AccordionInstruments = ({ data, type, titulo }: AccordionInstrumentsProps) => {

    type LeituraType = 'cota' | 'deslocamento' | 'profundidade_pio' | 'vazao' | 'leitura_diaria' | 'angulo' | 'deslocamento';

    let leituraType: LeituraType = 'cota';

    const formatDate = (dateStr: string | null | undefined) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleDateString('pt-BR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            timeZone: 'UTC'
        });
    };

    const formatDecimal = (value: string | number | null | undefined) => {
        if (value === null || value === undefined || value === '') return '';

        const parsedValue =
            typeof value === 'number'
                ? value
                : Number(
                    String(value)
                        .trim()
                        .replace(',', '.')
                );

        if (Number.isNaN(parsedValue)) {
            return String(value);
        }

        return parsedValue.toFixed(2).replace('.', ',');
    };

    if (type === 'Piezômetro' || type === 'Régua') {
        leituraType = 'cota';
    } else if (type === 'Indicadore') {
        leituraType = 'cota';
    } else if (type === 'Pluviômetro') {
        leituraType = 'leitura_diaria';
    } else if (type === 'Ré') {
        leituraType = 'angulo';
    } else if (type === 'vazao') {
        leituraType = 'vazao';
    } else if (type === 'inclinometro') {
        leituraType = 'deslocamento';
    }

    if (type === 'Marco') {
        return (
            <Accordion variant='outlined' sx={{ borderRadius: '25px', overflow: 'hidden' }} square={true} disableGutters={true}>
                <AccordionSummary expandIcon={<ExpandMore />}><Typography><strong>Última leitura {titulo}</strong></Typography></AccordionSummary>
                <AccordionDetails>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align='center'>Nome</TableCell>
                                <TableCell align='center'>Valor</TableCell>
                                <TableCell align='center'>Data</TableCell>
                                <TableCell align='center'>Nível de Perigo</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell align='center'>{item.nome}</TableCell>
                                    <TableCell align='center'>
                                        <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                                            Deslocamento X:
                                            {item.leituras.length > 0 && (
                                                formatDecimal(
                                                    item.leituras
                                                        .filter(leitura => leitura.desl_abs_x)
                                                        .reduce((max, leitura) => new Date(leitura.data_leitura) > new Date(max.data_leitura) ? leitura : max, item.leituras[0]).desl_abs_x
                                                )
                                            )}
                                            Deslocamento Z:
                                            {item.leituras.length > 0 && (
                                                formatDecimal(
                                                    item.leituras
                                                        .filter(leitura => leitura.desl_abs_z)
                                                        .reduce((max, leitura) => new Date(leitura.data_leitura) > new Date(max.data_leitura) ? leitura : max, item.leituras[0]).desl_abs_z
                                                )
                                            )}
                                            Deslocamento Y:
                                            {item.leituras.length > 0 && (
                                                formatDecimal(
                                                    item.leituras
                                                        .filter(leitura => leitura.desl_abs_y)
                                                        .reduce((max, leitura) => new Date(leitura.data_leitura) > new Date(max.data_leitura) ? leitura : max, item.leituras[0]).desl_abs_y
                                                )
                                            )}
                                        </Box>
                                    </TableCell>
                                    <TableCell align='center'>
                                        {item.leituras.length > 0 && (
                                            formatDate(
                                                item.leituras
                                                    .filter(leitura => leitura[leituraType])
                                                    .reduce((max, leitura) => new Date(leitura.data_leitura) > new Date(max.data_leitura) ? leitura : max, item.leituras[0]).data_leitura
                                            )
                                        )}
                                    </TableCell>
                                    <TableCell align='center'>{item.leituras[0]?.nivel_alerta}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </AccordionDetails>
            </Accordion>
        );
    }

    return (
        <Accordion variant='outlined' sx={{ borderRadius: '25px', overflow: 'hidden' }} square={true} disableGutters={true} >
            <AccordionSummary expandIcon={<ExpandMore />}><Typography><strong>Última leitura {titulo}</strong></Typography></AccordionSummary>
            <AccordionDetails>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align='center'>Nome</TableCell>
                            <TableCell align='center'>Valor</TableCell>
                            <TableCell align='center'>Data</TableCell>
                            <TableCell align='center'>Nível</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell align='center'>{item.nome}</TableCell>
                                <TableCell align='center'>
                                    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                                        {item.leituras.length > 0 && (
                                            formatDecimal(
                                                item.leituras
                                                    .filter(leitura => leitura[leituraType])
                                                    .reduce((max, leitura) => new Date(leitura.data_leitura) > new Date(max.data_leitura) ? leitura : max, item.leituras[0])[leituraType]
                                            )
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell align='center'>
                                    {item.leituras.length > 0 && (
                                        formatDate(
                                            item.leituras
                                                .filter(leitura => leitura[leituraType])
                                                .reduce((max, leitura) => new Date(leitura.data_leitura) > new Date(max.data_leitura) ? leitura : max, item.leituras[0]).data_leitura
                                        )
                                    )}
                                </TableCell>
                                <TableCell align='center'>{item.leituras[0]?.nivel_alerta}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </AccordionDetails>
        </Accordion >
    );
};